import {
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MarketplaceFooter from 'components/footer-marketplace/MarketplaceFooter';
import Spinner from 'components/Spinner';
import HubspotForm from 'react-hubspot-form';
import ShopNavBar from 'pages/shop-home-page/shop-nav-bar';
import './index.scss';
import { Breadcrumbs } from 'components/breadcrumbs';

const Contactus = () => (
  <>
    <ShopNavBar />
    <Breadcrumbs
      label="We want to hear from you"
      bg="/images/BLOCKCHAIN_ICE.jpg"
    />
    <section id="contact-us">
      <div className="container px-4 md:px-0">
        <div className="grid">
          <div className="col-12 md:col-8 md:col-offset-2 pt-5 pb-2 header-section">
            <h2>Contact us</h2>
            <p>
              We have provided you with a number of ways to communicate with us.
              Feel free to use the information or form below, or{' '}
              <br className="block md:hidden" />
              <a
                className="contact-us__link-join-our-cause"
                href="https://crowdpointtech.com/join-our-cause"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textTransform: 'capitalize',
                  letterSpacing: '1px',
                }}
              >
                Join our cause
              </a>
              .
            </p>
          </div>
        </div>
        <div className="grid pb-5">
          <div className="col-12 md:col-offset-1 md:col-10">
            <HubspotForm
              portalId="7175493"
              formId="a604d73e-7d26-4863-9bb2-dff0d1223fa0"
              cssClass="contactForm"
              loading={<Spinner />}
            />
            <div className="grid py-5">
              <div className="col-12 md:6 lg:col-4">
                <div className="contact-item">
                  <FontAwesomeIcon icon={faPhone} />
                  <div className="title">Call Us</div>
                  <div className="text">+1 (512) 767-1773</div>
                </div>
              </div>
              <div className="col-12 md:6 lg:col-4">
                <div className="contact-item">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <div className="title">Address</div>
                  <div className="text">
                    10815 Ranch Rd 2222, Building 3B Suite 100-527, Austin, TX
                    78730.
                  </div>
                </div>
              </div>
              <div className="col-12 md:12 lg:col-4">
                <div className="contact-item">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <div className="title">Email</div>
                  <a
                    href="mailto:contact@crowdpointtech.com"
                    className="text contact-us__mailto"
                  >
                    contact@crowdpointtech.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <MarketplaceFooter />
  </>
);

export default Contactus;
